<script setup>
import Notification from './Notification.vue';

const { state } = useStore();

const notifications = computed(() => state.notifications);
</script>

<template>
   <div class="notifications">
      <Notification v-for="notification in notifications" :key="notification.id" :notification="notification" />
   </div>
</template>

<style lang="scss" scoped>
.notifications {
   z-index: var(--zindex-tooltip);
   position: fixed;
   right: 1rem;
   bottom: 1rem;
   display: flex;
   flex-direction: column;
   align-items: flex-end;

   &::-webkit-scrollbar {
      visibility: hidden;
   }
}
</style>
